import type { PropsWithChildren } from "react";

import classNames from "classnames";

import { ResponsiveContainer } from "../ResponsiveContainer/ResponsiveContainer";

import styles from "./ImageBackgroundContainer.module.scss";

export type ImageBackgroundContainerType = PropsWithChildren<{
  background: string;
  fullWidth?: boolean;
  mobileBackground?: string;
  withAnimation?: boolean;
  withBlur?: boolean;
  className?: string;
}>;

export const ImageBackgroundContainer = ({
  children,
  fullWidth = false,
  background,
  mobileBackground = "",
  withAnimation = false,
  withBlur,
  className,
}: ImageBackgroundContainerType) => {
  const classes = classNames(styles.container, className, {
    [styles.mobile]: mobileBackground,
    [styles.fullWidth]: fullWidth,
    [styles.animated]: withAnimation,
  });

  return (
    <ResponsiveContainer fullWidth={fullWidth}>
      <div data-testid="background-image-container" className={classes}>
        <div className={styles.wrapper}>
          <div
            role="img"
            className={classNames(styles.image, { [styles.withBlur]: withBlur })}
            aria-label="background-image"
            data-testid="background-image"
            style={
              {
                "--mobile-background": `url("${mobileBackground || background}")`,
                "--background": `url("${background}")`,
              } as React.CSSProperties
            }
          />
        </div>
        <div className={styles.content}>{children}</div>
      </div>
    </ResponsiveContainer>
  );
};
